import Person from "@/types/Person.interface"
import XeroAccount from "@/types/XeroAccount.interface"

interface State {
    xeroAccount: XeroAccount
    xeroConnection: boolean
}

const defaults = () => {
    return {
        xeroAccount: null,
        xeroConnection: null,
    }
}

export default {
    state: defaults(),
    mutations: {
        xeroAccountSet (state: State, object: XeroAccount): void {
            state.xeroAccount = object
        },
        xeroConnectionSet (state: State, bool: boolean): void {
            state.xeroConnection = bool
        },
        xeroReset (state: State): void {
            Object.assign(state, defaults())
        },
    },
    actions: {
        linkXeroAccount ({ dispatch }, creds: object): Promise<void> {
            //  Send the request with our creds
            return window.axios.post('/xero/link-accounts', creds).then(response => {
                //  Refresh our auth user
                dispatch('authUserGet', response.data.token)
            }).catch(() => null)
        },
        xeroConnect ({ getters }): Promise<boolean> {
            //  Assemble the API endpoint
            const url = `${getters.api}/xero/oauth/connect/redirect`

            //  Send the request
            return window.axios.get(url).then(response => {
                //  Return true since we succeeded
                return true
            }).catch(() => null)
        },
        xeroDisconnect ({ commit, getters }): Promise<boolean> {
            //  Assemble the API endpoint
            const url = `${getters.api}/xero/disconnect`

            //  Send the request
            return window.axios.get(url).then(() => {
                //  Set our xero connection to false since we disconnected
                commit('xeroConnectionSet', false)

                //  Set our xero account to null since we disconnected
                commit('xeroAccountSet', null)

                //  Return true since we succeeded
                return true
            }).catch(() => null)
        },
        xeroSync ({ getters }): Promise<boolean> {
            //  Assemble the API endpoint
            const url = `${getters.api}/xero/sync`

            //  Send the request
            return window.axios.get(url).then(() => {
                //  Return true since we succeeded
                return true
            }).catch((e) => e.response.status)
        },
        xeroConnection ({ commit, getters }): Promise<boolean> {
            //  Assemble the API endpoint
            const url = `${getters.api}/xero/connection`

            //  Send the request
            return window.axios.get(url).then((response) => {
                //  Set our xero connection to our api response
                commit('xeroConnectionSet', response.data)

                //  Return the response
                return response.data
            }).catch(() => null)
        }
    },
    getters: {
        xeroAccount (state: State): XeroAccount {
            return state.xeroAccount
        },
        xeroHasAccount(_, getters): boolean {
            //  Get the current tenant
            const tenant = getters.tenant

            //  IF the tenant does NOT exist, return false
            if (!tenant) return false

            //  Else, check if the tenant data provider is QBO
            const hasXero = tenant.data_provider === 'XERO'

            //  Return the result
            return hasXero
        },
        xeroConnection (state: State): boolean {
            return state.xeroConnection
        },
        xeroContactArchived: (_) => (person: Person): boolean => {
            // if (!person.xero_contact) return false
            // return person.xero_contact.status === 'ARCHIVED'

            //  Just like with qbo, I cannot find references to xero contact so i am setting this to false
            return false
        }
    }
}
